import React from 'react';
import Discharge from './Discharge';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { QUERY_KEYS_SIA } from '../../../Common/hooks/useChartsData';
import { subtitlesMap } from '../../Common/maps/subtitleMap';

const ExitsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Total Altas nos Atendimentos'
            }}
            queryConfig={{
                key: QUERY_KEYS_SIA.DISCHARGE,
                url: 'governanceroom/dashboard/services/outs'
            }}
            subtitlesMap={subtitlesMap}
        >
            <Discharge />
        </ServicesChartsDataProvider>
    );
};

export default ExitsWrapper;
